// This file is auto-generated by @hey-api/openapi-ts

import { type Client, formDataBodySerializer, type Options as Options2, type TDataShape } from './client';
import { client } from './client.gen';
import type { AdminAddHomeNetworkData, AdminAddHomeNetworkErrors, AdminAddHomeNetworkResponses, AdminClearDeviceBrowsingActivityData, AdminClearDeviceBrowsingActivityErrors, AdminClearDeviceBrowsingActivityResponses, AdminClearDeviceWindowCapturesData, AdminClearDeviceWindowCapturesErrors, AdminClearDeviceWindowCapturesResponses, AdminConfirmFilteringRuleData, AdminConfirmFilteringRuleErrors, AdminConfirmFilteringRuleResponses, AdminCreateDeviceData, AdminCreateDeviceErrors, AdminCreateDeviceResponses, AdminCreateFamilyData, AdminCreateFamilyErrors, AdminCreateFamilyResponses, AdminCreateParentData, AdminCreateParentErrors, AdminCreateParentResponses, AdminDeleteDeviceData, AdminDeleteDeviceErrors, AdminDeleteDeviceResponses, AdminDeleteDeviceScreenshotsData, AdminDeleteDeviceScreenshotsErrors, AdminDeleteDeviceScreenshotsResponses, AdminDeleteFamilyData, AdminDeleteFamilyErrors, AdminDeleteFamilyResponses, AdminDeleteFilteringRuleData, AdminDeleteFilteringRuleErrors, AdminDeleteFilteringRuleResponses, AdminDeleteHomeNetworkData, AdminDeleteHomeNetworkErrors, AdminDeleteHomeNetworkResponses, AdminDeleteParentData, AdminDeleteParentErrors, AdminDeleteParentResponses, AdminDeviceBrowsingActivityData, AdminDeviceBrowsingActivityErrors, AdminDeviceBrowsingActivityResponses, AdminDeviceDetailData, AdminDeviceDetailErrors, AdminDeviceDetailResponses, AdminDeviceScreenshotsData, AdminDeviceScreenshotsErrors, AdminDeviceScreenshotsResponses, AdminDeviceWindowCapturesData, AdminDeviceWindowCapturesErrors, AdminDeviceWindowCapturesResponses, AdminFamilyDetailData, AdminFamilyDetailErrors, AdminFamilyDetailResponses, AdminGenerateFilteringRuleData, AdminGenerateFilteringRuleErrors, AdminGenerateFilteringRuleResponses, AdminGetDeploymentSettingsData, AdminGetDeploymentSettingsErrors, AdminGetDeploymentSettingsResponses, AdminListAgentBundlesData, AdminListAgentBundlesErrors, AdminListAgentBundlesResponses, AdminListCommandsData, AdminListCommandsErrors, AdminListCommandsResponses, AdminListExtensionReleasesData, AdminListExtensionReleasesErrors, AdminListExtensionReleasesResponses, AdminListFamiliesData, AdminListFamiliesErrors, AdminListFamiliesResponses, AdminListFilteringRulesData, AdminListFilteringRulesErrors, AdminListFilteringRulesResponses, AdminListHomeNetworksData, AdminListHomeNetworksErrors, AdminListHomeNetworksResponses, AdminListModuleRegistryData, AdminListModuleRegistryErrors, AdminListModuleRegistryResponses, AdminListModulesData, AdminListModulesErrors, AdminListModulesResponses, AdminQueueCommandData, AdminQueueCommandErrors, AdminQueueCommandResponses, AdminReadFilteringRuleData, AdminReadFilteringRuleErrors, AdminReadFilteringRuleResponses, AdminScreenshotImageData, AdminScreenshotImageErrors, AdminScreenshotImageResponses, AdminSetFilteringRuleEnabledData, AdminSetFilteringRuleEnabledErrors, AdminSetFilteringRuleEnabledResponses, AdminSetModuleData, AdminSetModuleErrors, AdminSetModuleResponses, AdminSetTargetVersionData, AdminSetTargetVersionErrors, AdminSetTargetVersionResponses, AdminUpdateDeploymentSettingsData, AdminUpdateDeploymentSettingsErrors, AdminUpdateDeploymentSettingsResponses, AdminUpdateDeviceData, AdminUpdateDeviceErrors, AdminUpdateDeviceResponses, AdminUpdateFamilyData, AdminUpdateFamilyErrors, AdminUpdateFamilyResponses, AdminUpdateParentData, AdminUpdateParentErrors, AdminUpdateParentResponses, AdminUploadAgentBundleData, AdminUploadAgentBundleErrors, AdminUploadAgentBundleResponses, AdminUploadExtensionReleaseData, AdminUploadExtensionReleaseErrors, AdminUploadExtensionReleaseResponses, AdminWindowCaptureData, AdminWindowCaptureErrors, AdminWindowCaptureResponses, DeviceActivityData, DeviceActivityErrors, DeviceActivityResponses, DeviceAgentBundleData, DeviceAgentBundleErrors, DeviceAgentBundleResponses, DeviceCapturesUploadData, DeviceCapturesUploadErrors, DeviceCapturesUploadResponses, DeviceDeviceCaptureV2ConfigData, DeviceDeviceCaptureV2ConfigErrors, DeviceDeviceCaptureV2ConfigResponses, DeviceDeviceConfigData, DeviceDeviceConfigErrors, DeviceDeviceConfigResponses, DeviceDownloadFileData, DeviceDownloadFileErrors, DeviceDownloadFileResponses, DeviceExtensionCrxData, DeviceExtensionCrxErrors, DeviceExtensionCrxResponses, DeviceExtensionUpdatesXmlData, DeviceExtensionUpdatesXmlResponses, DeviceHeartbeatData, DeviceHeartbeatErrors, DeviceHeartbeatResponses, DeviceScreenshotsLiveData, DeviceScreenshotsLiveResponses, DeviceScreenshotsUploadData, DeviceScreenshotsUploadResponses, MetaHealthData, MetaHealthResponses, ParentAuthChangePasswordData, ParentAuthChangePasswordErrors, ParentAuthChangePasswordResponses, ParentAuthLoginData, ParentAuthLoginErrors, ParentAuthLoginResponses, ParentAuthLogoutData, ParentAuthLogoutResponses, ParentAuthMeData, ParentAuthMeErrors, ParentAuthMeResponses, ParentReadDeviceDetailData, ParentReadDeviceDetailErrors, ParentReadDeviceDetailResponses, ParentReadDeviceScreenshotsData, ParentReadDeviceScreenshotsErrors, ParentReadDeviceScreenshotsResponses, ParentReadDevicesData, ParentReadDevicesErrors, ParentReadDevicesResponses, ParentReadFamilyData, ParentReadFamilyErrors, ParentReadFamilyResponses, ParentReadScreenshotImageData, ParentReadScreenshotImageErrors, ParentReadScreenshotImageResponses, ParentReadScreenshotThumbnailData, ParentReadScreenshotThumbnailErrors, ParentReadScreenshotThumbnailResponses, ParentRulesConfirmData, ParentRulesConfirmErrors, ParentRulesConfirmResponses, ParentRulesDeleteData, ParentRulesDeleteErrors, ParentRulesDeleteResponses, ParentRulesGenerateData, ParentRulesGenerateErrors, ParentRulesGenerateResponses, ParentRulesListData, ParentRulesListErrors, ParentRulesListResponses, ParentRulesReadData, ParentRulesReadErrors, ParentRulesReadResponses, ParentRulesSetEnabledData, ParentRulesSetEnabledErrors, ParentRulesSetEnabledResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Change Password
 */
export const parentAuthChangePassword = <ThrowOnError extends boolean = false>(options: Options<ParentAuthChangePasswordData, ThrowOnError>) => (options.client ?? client).post<ParentAuthChangePasswordResponses, ParentAuthChangePasswordErrors, ThrowOnError>({
    url: '/api/account/password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Activity
 */
export const deviceActivity = <ThrowOnError extends boolean = false>(options: Options<DeviceActivityData, ThrowOnError>) => (options.client ?? client).post<DeviceActivityResponses, DeviceActivityErrors, ThrowOnError>({
    url: '/api/activity',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Agent Bundles
 */
export const adminListAgentBundles = <ThrowOnError extends boolean = false>(options?: Options<AdminListAgentBundlesData, ThrowOnError>) => (options?.client ?? client).get<AdminListAgentBundlesResponses, AdminListAgentBundlesErrors, ThrowOnError>({ url: '/api/admin/agent-bundles', ...options });

/**
 * Upload Agent Bundle
 */
export const adminUploadAgentBundle = <ThrowOnError extends boolean = false>(options: Options<AdminUploadAgentBundleData, ThrowOnError>) => (options.client ?? client).post<AdminUploadAgentBundleResponses, AdminUploadAgentBundleErrors, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/api/admin/agent-bundles',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Get Deployment Settings
 */
export const adminGetDeploymentSettings = <ThrowOnError extends boolean = false>(options?: Options<AdminGetDeploymentSettingsData, ThrowOnError>) => (options?.client ?? client).get<AdminGetDeploymentSettingsResponses, AdminGetDeploymentSettingsErrors, ThrowOnError>({ url: '/api/admin/deployment-settings', ...options });

/**
 * Update Deployment Settings
 */
export const adminUpdateDeploymentSettings = <ThrowOnError extends boolean = false>(options: Options<AdminUpdateDeploymentSettingsData, ThrowOnError>) => (options.client ?? client).put<AdminUpdateDeploymentSettingsResponses, AdminUpdateDeploymentSettingsErrors, ThrowOnError>({
    url: '/api/admin/deployment-settings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Clear Device Browsing Activity
 */
export const adminClearDeviceBrowsingActivity = <ThrowOnError extends boolean = false>(options: Options<AdminClearDeviceBrowsingActivityData, ThrowOnError>) => (options.client ?? client).delete<AdminClearDeviceBrowsingActivityResponses, AdminClearDeviceBrowsingActivityErrors, ThrowOnError>({ url: '/api/admin/devices/{device_id}/browsing-activity', ...options });

/**
 * Device Browsing Activity
 */
export const adminDeviceBrowsingActivity = <ThrowOnError extends boolean = false>(options: Options<AdminDeviceBrowsingActivityData, ThrowOnError>) => (options.client ?? client).get<AdminDeviceBrowsingActivityResponses, AdminDeviceBrowsingActivityErrors, ThrowOnError>({ url: '/api/admin/devices/{device_id}/browsing-activity', ...options });

/**
 * List Commands
 */
export const adminListCommands = <ThrowOnError extends boolean = false>(options: Options<AdminListCommandsData, ThrowOnError>) => (options.client ?? client).get<AdminListCommandsResponses, AdminListCommandsErrors, ThrowOnError>({ url: '/api/admin/devices/{device_id}/commands', ...options });

/**
 * Queue Command
 */
export const adminQueueCommand = <ThrowOnError extends boolean = false>(options: Options<AdminQueueCommandData, ThrowOnError>) => (options.client ?? client).post<AdminQueueCommandResponses, AdminQueueCommandErrors, ThrowOnError>({
    url: '/api/admin/devices/{device_id}/commands',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Filtering Rules
 */
export const adminListFilteringRules = <ThrowOnError extends boolean = false>(options: Options<AdminListFilteringRulesData, ThrowOnError>) => (options.client ?? client).get<AdminListFilteringRulesResponses, AdminListFilteringRulesErrors, ThrowOnError>({ url: '/api/admin/devices/{device_id}/filtering-rules', ...options });

/**
 * Generate Filtering Rule
 */
export const adminGenerateFilteringRule = <ThrowOnError extends boolean = false>(options: Options<AdminGenerateFilteringRuleData, ThrowOnError>) => (options.client ?? client).post<AdminGenerateFilteringRuleResponses, AdminGenerateFilteringRuleErrors, ThrowOnError>({
    url: '/api/admin/devices/{device_id}/filtering-rules/generate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Filtering Rule
 */
export const adminDeleteFilteringRule = <ThrowOnError extends boolean = false>(options: Options<AdminDeleteFilteringRuleData, ThrowOnError>) => (options.client ?? client).delete<AdminDeleteFilteringRuleResponses, AdminDeleteFilteringRuleErrors, ThrowOnError>({ url: '/api/admin/devices/{device_id}/filtering-rules/{rule_id}', ...options });

/**
 * Read Filtering Rule
 */
export const adminReadFilteringRule = <ThrowOnError extends boolean = false>(options: Options<AdminReadFilteringRuleData, ThrowOnError>) => (options.client ?? client).get<AdminReadFilteringRuleResponses, AdminReadFilteringRuleErrors, ThrowOnError>({ url: '/api/admin/devices/{device_id}/filtering-rules/{rule_id}', ...options });

/**
 * Confirm Filtering Rule
 */
export const adminConfirmFilteringRule = <ThrowOnError extends boolean = false>(options: Options<AdminConfirmFilteringRuleData, ThrowOnError>) => (options.client ?? client).post<AdminConfirmFilteringRuleResponses, AdminConfirmFilteringRuleErrors, ThrowOnError>({ url: '/api/admin/devices/{device_id}/filtering-rules/{rule_id}/confirm', ...options });

/**
 * Set Filtering Rule Enabled
 */
export const adminSetFilteringRuleEnabled = <ThrowOnError extends boolean = false>(options: Options<AdminSetFilteringRuleEnabledData, ThrowOnError>) => (options.client ?? client).put<AdminSetFilteringRuleEnabledResponses, AdminSetFilteringRuleEnabledErrors, ThrowOnError>({
    url: '/api/admin/devices/{device_id}/filtering-rules/{rule_id}/enabled',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Home Network
 */
export const adminDeleteHomeNetwork = <ThrowOnError extends boolean = false>(options: Options<AdminDeleteHomeNetworkData, ThrowOnError>) => (options.client ?? client).delete<AdminDeleteHomeNetworkResponses, AdminDeleteHomeNetworkErrors, ThrowOnError>({ url: '/api/admin/devices/{device_id}/home-networks', ...options });

/**
 * List Home Networks
 */
export const adminListHomeNetworks = <ThrowOnError extends boolean = false>(options: Options<AdminListHomeNetworksData, ThrowOnError>) => (options.client ?? client).get<AdminListHomeNetworksResponses, AdminListHomeNetworksErrors, ThrowOnError>({ url: '/api/admin/devices/{device_id}/home-networks', ...options });

/**
 * Add Home Network
 */
export const adminAddHomeNetwork = <ThrowOnError extends boolean = false>(options: Options<AdminAddHomeNetworkData, ThrowOnError>) => (options.client ?? client).post<AdminAddHomeNetworkResponses, AdminAddHomeNetworkErrors, ThrowOnError>({
    url: '/api/admin/devices/{device_id}/home-networks',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Modules
 */
export const adminListModules = <ThrowOnError extends boolean = false>(options: Options<AdminListModulesData, ThrowOnError>) => (options.client ?? client).get<AdminListModulesResponses, AdminListModulesErrors, ThrowOnError>({ url: '/api/admin/devices/{device_id}/modules', ...options });

/**
 * Set Module
 */
export const adminSetModule = <ThrowOnError extends boolean = false>(options: Options<AdminSetModuleData, ThrowOnError>) => (options.client ?? client).put<AdminSetModuleResponses, AdminSetModuleErrors, ThrowOnError>({
    url: '/api/admin/devices/{device_id}/modules',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Device Screenshots
 */
export const adminDeleteDeviceScreenshots = <ThrowOnError extends boolean = false>(options: Options<AdminDeleteDeviceScreenshotsData, ThrowOnError>) => (options.client ?? client).delete<AdminDeleteDeviceScreenshotsResponses, AdminDeleteDeviceScreenshotsErrors, ThrowOnError>({ url: '/api/admin/devices/{device_id}/screenshots', ...options });

/**
 * Device Screenshots
 */
export const adminDeviceScreenshots = <ThrowOnError extends boolean = false>(options: Options<AdminDeviceScreenshotsData, ThrowOnError>) => (options.client ?? client).get<AdminDeviceScreenshotsResponses, AdminDeviceScreenshotsErrors, ThrowOnError>({ url: '/api/admin/devices/{device_id}/screenshots', ...options });

/**
 * Set Target Version
 */
export const adminSetTargetVersion = <ThrowOnError extends boolean = false>(options: Options<AdminSetTargetVersionData, ThrowOnError>) => (options.client ?? client).put<AdminSetTargetVersionResponses, AdminSetTargetVersionErrors, ThrowOnError>({
    url: '/api/admin/devices/{device_id}/target-version',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Clear Device Window Captures
 */
export const adminClearDeviceWindowCaptures = <ThrowOnError extends boolean = false>(options: Options<AdminClearDeviceWindowCapturesData, ThrowOnError>) => (options.client ?? client).delete<AdminClearDeviceWindowCapturesResponses, AdminClearDeviceWindowCapturesErrors, ThrowOnError>({ url: '/api/admin/devices/{device_id}/window-captures', ...options });

/**
 * Device Window Captures
 */
export const adminDeviceWindowCaptures = <ThrowOnError extends boolean = false>(options: Options<AdminDeviceWindowCapturesData, ThrowOnError>) => (options.client ?? client).get<AdminDeviceWindowCapturesResponses, AdminDeviceWindowCapturesErrors, ThrowOnError>({ url: '/api/admin/devices/{device_id}/window-captures', ...options });

/**
 * List Extension Releases
 */
export const adminListExtensionReleases = <ThrowOnError extends boolean = false>(options?: Options<AdminListExtensionReleasesData, ThrowOnError>) => (options?.client ?? client).get<AdminListExtensionReleasesResponses, AdminListExtensionReleasesErrors, ThrowOnError>({ url: '/api/admin/extension-releases', ...options });

/**
 * Upload Extension Release
 */
export const adminUploadExtensionRelease = <ThrowOnError extends boolean = false>(options: Options<AdminUploadExtensionReleaseData, ThrowOnError>) => (options.client ?? client).post<AdminUploadExtensionReleaseResponses, AdminUploadExtensionReleaseErrors, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/api/admin/extension-releases',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * List Families
 */
export const adminListFamilies = <ThrowOnError extends boolean = false>(options?: Options<AdminListFamiliesData, ThrowOnError>) => (options?.client ?? client).get<AdminListFamiliesResponses, AdminListFamiliesErrors, ThrowOnError>({ url: '/api/admin/families', ...options });

/**
 * Create Family
 */
export const adminCreateFamily = <ThrowOnError extends boolean = false>(options: Options<AdminCreateFamilyData, ThrowOnError>) => (options.client ?? client).post<AdminCreateFamilyResponses, AdminCreateFamilyErrors, ThrowOnError>({
    url: '/api/admin/families',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Family
 */
export const adminDeleteFamily = <ThrowOnError extends boolean = false>(options: Options<AdminDeleteFamilyData, ThrowOnError>) => (options.client ?? client).delete<AdminDeleteFamilyResponses, AdminDeleteFamilyErrors, ThrowOnError>({ url: '/api/admin/families/{family_id}', ...options });

/**
 * Family Detail
 */
export const adminFamilyDetail = <ThrowOnError extends boolean = false>(options: Options<AdminFamilyDetailData, ThrowOnError>) => (options.client ?? client).get<AdminFamilyDetailResponses, AdminFamilyDetailErrors, ThrowOnError>({ url: '/api/admin/families/{family_id}', ...options });

/**
 * Update Family
 */
export const adminUpdateFamily = <ThrowOnError extends boolean = false>(options: Options<AdminUpdateFamilyData, ThrowOnError>) => (options.client ?? client).put<AdminUpdateFamilyResponses, AdminUpdateFamilyErrors, ThrowOnError>({
    url: '/api/admin/families/{family_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Device
 */
export const adminCreateDevice = <ThrowOnError extends boolean = false>(options: Options<AdminCreateDeviceData, ThrowOnError>) => (options.client ?? client).post<AdminCreateDeviceResponses, AdminCreateDeviceErrors, ThrowOnError>({
    url: '/api/admin/families/{family_id}/devices',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Device
 */
export const adminDeleteDevice = <ThrowOnError extends boolean = false>(options: Options<AdminDeleteDeviceData, ThrowOnError>) => (options.client ?? client).delete<AdminDeleteDeviceResponses, AdminDeleteDeviceErrors, ThrowOnError>({ url: '/api/admin/families/{family_id}/devices/{device_id}', ...options });

/**
 * Device Detail
 */
export const adminDeviceDetail = <ThrowOnError extends boolean = false>(options: Options<AdminDeviceDetailData, ThrowOnError>) => (options.client ?? client).get<AdminDeviceDetailResponses, AdminDeviceDetailErrors, ThrowOnError>({ url: '/api/admin/families/{family_id}/devices/{device_id}', ...options });

/**
 * Update Device
 */
export const adminUpdateDevice = <ThrowOnError extends boolean = false>(options: Options<AdminUpdateDeviceData, ThrowOnError>) => (options.client ?? client).put<AdminUpdateDeviceResponses, AdminUpdateDeviceErrors, ThrowOnError>({
    url: '/api/admin/families/{family_id}/devices/{device_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Parent
 */
export const adminCreateParent = <ThrowOnError extends boolean = false>(options: Options<AdminCreateParentData, ThrowOnError>) => (options.client ?? client).post<AdminCreateParentResponses, AdminCreateParentErrors, ThrowOnError>({
    url: '/api/admin/families/{family_id}/parents',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Parent
 */
export const adminDeleteParent = <ThrowOnError extends boolean = false>(options: Options<AdminDeleteParentData, ThrowOnError>) => (options.client ?? client).delete<AdminDeleteParentResponses, AdminDeleteParentErrors, ThrowOnError>({ url: '/api/admin/families/{family_id}/parents/{parent_id}', ...options });

/**
 * Update Parent
 */
export const adminUpdateParent = <ThrowOnError extends boolean = false>(options: Options<AdminUpdateParentData, ThrowOnError>) => (options.client ?? client).put<AdminUpdateParentResponses, AdminUpdateParentErrors, ThrowOnError>({
    url: '/api/admin/families/{family_id}/parents/{parent_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Module Registry
 */
export const adminListModuleRegistry = <ThrowOnError extends boolean = false>(options?: Options<AdminListModuleRegistryData, ThrowOnError>) => (options?.client ?? client).get<AdminListModuleRegistryResponses, AdminListModuleRegistryErrors, ThrowOnError>({ url: '/api/admin/modules', ...options });

/**
 * Screenshot Image
 */
export const adminScreenshotImage = <ThrowOnError extends boolean = false>(options: Options<AdminScreenshotImageData, ThrowOnError>) => (options.client ?? client).get<AdminScreenshotImageResponses, AdminScreenshotImageErrors, ThrowOnError>({ url: '/api/admin/screenshots/{screenshot_id}/image', ...options });

/**
 * Window Capture
 */
export const adminWindowCapture = <ThrowOnError extends boolean = false>(options: Options<AdminWindowCaptureData, ThrowOnError>) => (options.client ?? client).get<AdminWindowCaptureResponses, AdminWindowCaptureErrors, ThrowOnError>({ url: '/api/admin/window-captures/{capture_id}', ...options });

/**
 * Agent Bundle
 */
export const deviceAgentBundle = <ThrowOnError extends boolean = false>(options: Options<DeviceAgentBundleData, ThrowOnError>) => (options.client ?? client).get<DeviceAgentBundleResponses, DeviceAgentBundleErrors, ThrowOnError>({ url: '/api/agent/bundle/{version}', ...options });

/**
 * Extension Updates Xml
 */
export const deviceExtensionUpdatesXml = <ThrowOnError extends boolean = false>(options?: Options<DeviceExtensionUpdatesXmlData, ThrowOnError>) => (options?.client ?? client).get<DeviceExtensionUpdatesXmlResponses, unknown, ThrowOnError>({ url: '/api/agent/extension/updates.xml', ...options });

/**
 * Extension Crx
 */
export const deviceExtensionCrx = <ThrowOnError extends boolean = false>(options: Options<DeviceExtensionCrxData, ThrowOnError>) => (options.client ?? client).get<DeviceExtensionCrxResponses, DeviceExtensionCrxErrors, ThrowOnError>({ url: '/api/agent/extension/{version}.crx', ...options });

/**
 * Heartbeat
 */
export const deviceHeartbeat = <ThrowOnError extends boolean = false>(options: Options<DeviceHeartbeatData, ThrowOnError>) => (options.client ?? client).post<DeviceHeartbeatResponses, DeviceHeartbeatErrors, ThrowOnError>({
    url: '/api/agent/heartbeat',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Captures Upload
 */
export const deviceCapturesUpload = <ThrowOnError extends boolean = false>(options: Options<DeviceCapturesUploadData, ThrowOnError>) => (options.client ?? client).post<DeviceCapturesUploadResponses, DeviceCapturesUploadErrors, ThrowOnError>({ url: '/api/captures/upload', ...options });

/**
 * Devices
 */
export const parentReadDevices = <ThrowOnError extends boolean = false>(options?: Options<ParentReadDevicesData, ThrowOnError>) => (options?.client ?? client).get<ParentReadDevicesResponses, ParentReadDevicesErrors, ThrowOnError>({ url: '/api/devices', ...options });

/**
 * Device Detail
 */
export const parentReadDeviceDetail = <ThrowOnError extends boolean = false>(options: Options<ParentReadDeviceDetailData, ThrowOnError>) => (options.client ?? client).get<ParentReadDeviceDetailResponses, ParentReadDeviceDetailErrors, ThrowOnError>({ url: '/api/devices/{device_id}', ...options });

/**
 * List
 */
export const parentRulesList = <ThrowOnError extends boolean = false>(options: Options<ParentRulesListData, ThrowOnError>) => (options.client ?? client).get<ParentRulesListResponses, ParentRulesListErrors, ThrowOnError>({ url: '/api/devices/{device_id}/filtering-rules', ...options });

/**
 * Generate
 */
export const parentRulesGenerate = <ThrowOnError extends boolean = false>(options: Options<ParentRulesGenerateData, ThrowOnError>) => (options.client ?? client).post<ParentRulesGenerateResponses, ParentRulesGenerateErrors, ThrowOnError>({
    url: '/api/devices/{device_id}/filtering-rules/generate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete
 */
export const parentRulesDelete = <ThrowOnError extends boolean = false>(options: Options<ParentRulesDeleteData, ThrowOnError>) => (options.client ?? client).delete<ParentRulesDeleteResponses, ParentRulesDeleteErrors, ThrowOnError>({ url: '/api/devices/{device_id}/filtering-rules/{rule_id}', ...options });

/**
 * Read
 */
export const parentRulesRead = <ThrowOnError extends boolean = false>(options: Options<ParentRulesReadData, ThrowOnError>) => (options.client ?? client).get<ParentRulesReadResponses, ParentRulesReadErrors, ThrowOnError>({ url: '/api/devices/{device_id}/filtering-rules/{rule_id}', ...options });

/**
 * Confirm
 */
export const parentRulesConfirm = <ThrowOnError extends boolean = false>(options: Options<ParentRulesConfirmData, ThrowOnError>) => (options.client ?? client).post<ParentRulesConfirmResponses, ParentRulesConfirmErrors, ThrowOnError>({ url: '/api/devices/{device_id}/filtering-rules/{rule_id}/confirm', ...options });

/**
 * Set Enabled
 */
export const parentRulesSetEnabled = <ThrowOnError extends boolean = false>(options: Options<ParentRulesSetEnabledData, ThrowOnError>) => (options.client ?? client).put<ParentRulesSetEnabledResponses, ParentRulesSetEnabledErrors, ThrowOnError>({
    url: '/api/devices/{device_id}/filtering-rules/{rule_id}/enabled',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Device Screenshots
 */
export const parentReadDeviceScreenshots = <ThrowOnError extends boolean = false>(options: Options<ParentReadDeviceScreenshotsData, ThrowOnError>) => (options.client ?? client).get<ParentReadDeviceScreenshotsResponses, ParentReadDeviceScreenshotsErrors, ThrowOnError>({ url: '/api/devices/{device_id}/screenshots', ...options });

/**
 * Device Capture V2 Config
 */
export const deviceDeviceCaptureV2Config = <ThrowOnError extends boolean = false>(options: Options<DeviceDeviceCaptureV2ConfigData, ThrowOnError>) => (options.client ?? client).get<DeviceDeviceCaptureV2ConfigResponses, DeviceDeviceCaptureV2ConfigErrors, ThrowOnError>({ url: '/api/devices/{serial}/capture-v2-config', ...options });

/**
 * Device Config
 */
export const deviceDeviceConfig = <ThrowOnError extends boolean = false>(options: Options<DeviceDeviceConfigData, ThrowOnError>) => (options.client ?? client).get<DeviceDeviceConfigResponses, DeviceDeviceConfigErrors, ThrowOnError>({ url: '/api/devices/{serial}/config', ...options });

/**
 * Download File
 */
export const deviceDownloadFile = <ThrowOnError extends boolean = false>(options: Options<DeviceDownloadFileData, ThrowOnError>) => (options.client ?? client).get<DeviceDownloadFileResponses, DeviceDownloadFileErrors, ThrowOnError>({ url: '/api/downloads/{filename}', ...options });

/**
 * Family
 */
export const parentReadFamily = <ThrowOnError extends boolean = false>(options?: Options<ParentReadFamilyData, ThrowOnError>) => (options?.client ?? client).get<ParentReadFamilyResponses, ParentReadFamilyErrors, ThrowOnError>({ url: '/api/family', ...options });

/**
 * Health
 */
export const metaHealth = <ThrowOnError extends boolean = false>(options?: Options<MetaHealthData, ThrowOnError>) => (options?.client ?? client).get<MetaHealthResponses, unknown, ThrowOnError>({ url: '/api/health', ...options });

/**
 * Login
 */
export const parentAuthLogin = <ThrowOnError extends boolean = false>(options: Options<ParentAuthLoginData, ThrowOnError>) => (options.client ?? client).post<ParentAuthLoginResponses, ParentAuthLoginErrors, ThrowOnError>({
    url: '/api/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Logout
 */
export const parentAuthLogout = <ThrowOnError extends boolean = false>(options?: Options<ParentAuthLogoutData, ThrowOnError>) => (options?.client ?? client).post<ParentAuthLogoutResponses, unknown, ThrowOnError>({ url: '/api/logout', ...options });

/**
 * Me
 */
export const parentAuthMe = <ThrowOnError extends boolean = false>(options?: Options<ParentAuthMeData, ThrowOnError>) => (options?.client ?? client).get<ParentAuthMeResponses, ParentAuthMeErrors, ThrowOnError>({ url: '/api/me', ...options });

/**
 * Screenshots Live
 */
export const deviceScreenshotsLive = <ThrowOnError extends boolean = false>(options?: Options<DeviceScreenshotsLiveData, ThrowOnError>) => (options?.client ?? client).post<DeviceScreenshotsLiveResponses, unknown, ThrowOnError>({ url: '/api/screenshots/live', ...options });

/**
 * Screenshots Upload
 */
export const deviceScreenshotsUpload = <ThrowOnError extends boolean = false>(options?: Options<DeviceScreenshotsUploadData, ThrowOnError>) => (options?.client ?? client).post<DeviceScreenshotsUploadResponses, unknown, ThrowOnError>({ url: '/api/screenshots/upload', ...options });

/**
 * Screenshot Image
 */
export const parentReadScreenshotImage = <ThrowOnError extends boolean = false>(options: Options<ParentReadScreenshotImageData, ThrowOnError>) => (options.client ?? client).get<ParentReadScreenshotImageResponses, ParentReadScreenshotImageErrors, ThrowOnError>({ url: '/api/screenshots/{screenshot_id}/image', ...options });

/**
 * Screenshot Thumbnail
 */
export const parentReadScreenshotThumbnail = <ThrowOnError extends boolean = false>(options: Options<ParentReadScreenshotThumbnailData, ThrowOnError>) => (options.client ?? client).get<ParentReadScreenshotThumbnailResponses, ParentReadScreenshotThumbnailErrors, ThrowOnError>({ url: '/api/screenshots/{screenshot_id}/thumbnail', ...options });
